import { render } from "./DashboardTagsMetricsGroup.vue?vue&type=template&id=77d4af2b&scoped=true"
import script from "./DashboardTagsMetricsGroup.vue?vue&type=script&lang=js"
export * from "./DashboardTagsMetricsGroup.vue?vue&type=script&lang=js"

import "./DashboardTagsMetricsGroup.vue?vue&type=style&index=0&id=77d4af2b&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77d4af2b"]])

export default __exports__